var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOlympicLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 130,
  height: 34,
  viewBox: "0 0 130 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.0027 32.3388C25.2884 32.3388 32.0053 25.6219 32.0053 17.3362C32.0053 9.05042 25.2884 2.3335 17.0027 2.3335C8.71692 2.3335 2 9.05042 2 17.3362C2 25.6219 8.71692 32.3388 17.0027 32.3388Z",
  stroke: "#3A7FCA",
  strokeWidth: 2.9417
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M41.0015 32.3388C49.2873 32.3388 56.0042 25.6219 56.0042 17.3362C56.0042 9.05042 49.2873 2.3335 41.0015 2.3335C32.7158 2.3335 25.9988 9.05042 25.9988 17.3362C25.9988 25.6219 32.7158 32.3388 41.0015 32.3388Z",
  stroke: "#F8A91D",
  strokeWidth: 2.9417
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M64.9999 32.3388C73.2857 32.3388 80.0026 25.6219 80.0026 17.3362C80.0026 9.05042 73.2857 2.3335 64.9999 2.3335C56.7142 2.3335 49.9973 9.05042 49.9973 17.3362C49.9973 25.6219 56.7142 32.3388 64.9999 32.3388Z",
  stroke: "#211C1D",
  strokeWidth: 2.9417
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M88.9988 32.3388C97.2845 32.3388 104.001 25.6219 104.001 17.3362C104.001 9.05042 97.2845 2.3335 88.9988 2.3335C80.713 2.3335 73.9961 9.05042 73.9961 17.3362C73.9961 25.6219 80.713 32.3388 88.9988 32.3388Z",
  stroke: "#2EAA46",
  strokeWidth: 2.9417
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M112.997 32.3388C121.283 32.3388 128 25.6219 128 17.3362C128 9.05042 121.283 2.3335 112.997 2.3335C104.711 2.3335 97.9945 9.05042 97.9945 17.3362C97.9945 25.6219 104.711 32.3388 112.997 32.3388Z",
  stroke: "#ED1E4A",
  strokeWidth: 2.9417
})));
export default SvgOlympicLogo;